import ViewAndDownloadFileStatsTable from './ViewAndDownloadFileStatsTable.component';

export default ViewAndDownloadFileStatsTable;
